export default __webpack_public_path__ + "static/jp1-a3650e4797925b0fef37bd644d7583ad.webp";